import RoutePath from 'components/RoutePath'
import LeftArrow from 'components/icons/LeftArrow'
import {
  CandidatesSpan,
  StyledTab,
  TopHeader,
  TopHeading,
} from 'modules/Exp-Candidates/DrivePage/style'
import DriveTable from 'modules/Exp-Candidates/DriveTable/index'
import {
  LeftSection,
  SectionName,
} from 'modules/Exp-Candidates/ViewDrive/Style/style'
import React, { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import { DriveTitle } from '../ViewDriveRole/CandidateDocumnets/InterviewerDrawer/style'
const { TabPane } = StyledTab

const DrivePage = ({
  getExpDriveListData,
  requestToChange,
  confirmDrive,
  setDashboardNavs,
  dashboardNavs,
  recreateCall,
}) => {
  const params = useParams()
  const tableRef = useRef(null)
  const [confirmation, setConfirmation] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [pageLimit] = useState(10)
  const [corporateStatus] = useState('')
  const [occurrence, setOccurrence] = useState('UPCOMING')
  const [searchValue, setSearchValue] = useState('')
  const [sortBy, setSortBy] = useState('')

  const [driveRoles, setDriveRoles] = useState([])
  const [driveMode, setDriveMode] = useState([])
  const [driveStatus, setDriveStatus] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [listOfDrivesDetails, setListOfDrivesDetails] = useState({})

  const onPageChange = pageNum => {
    setCurrentPage(pageNum)
  }

  const tabOnchange = tab => {
    setOccurrence(tab)
    setCurrentPage(1)
  }

  const onChangeSort = (pagination, filter, sorter) => {
    setSortBy(sorter)
  }
  useEffect(() => {
    tableRef.current.scrollIntoView({
      behavior: 'smooth',
    })
  }, [currentPage])
  useEffect(() => {
    if (dashboardNavs) {
      setOccurrence(dashboardNavs)
    }
    return setDashboardNavs(null)
  }, [])

  const getDariveData = async driveStartDate => {
    setIsLoading(false)
    const roleId = params?.expcandidatesId
    let response = await getExpDriveListData({
      roleId,
      currentPage,
      searchValue,
      corporateStatus,
      occurrence: dashboardNavs || occurrence,
      driveRoles,
      driveMode,
      driveStatus,
      sortBy,
      driveStartDate: driveStartDate || '',
      pageLimit,
    })
    if (response?.status >= 200 && response?.status <= 300) {
      setListOfDrivesDetails(response?.data?.data)
      setIsLoading(true)
    } else {
      setIsLoading(true)
    }
  }

  useEffect(() => {
    if (!dashboardNavs) {
      getDariveData()
    }
  }, [currentPage, pageLimit, searchValue, corporateStatus, occurrence, sortBy])

  const tabList = [
    {
      key: 'UPCOMING',
      tabName: ' Drives',
      count: getZeroBeforeInt(listOfDrivesDetails?.upComingDriveCount),
    },
  ]
  return (
    <>
      <TopHeader row spaceBetween alignCenter>
        <TopHeading flexStart column ref={tableRef}>
          <LeftSection centerVertically>
            <Link to="/expcandidates">
              <LeftArrow />
            </Link>
            <SectionName column>
              <RoutePath
                from="Experienced Candidate"
                on={'Drive'}
                path="/expcandidates"
              />

              <DriveTitle>Drive</DriveTitle>
            </SectionName>
          </LeftSection>
        </TopHeading>
      </TopHeader>

      <StyledTab activeKey={occurrence} onChange={tabOnchange}>
        {tabList?.map(item => {
          return (
            <TabPane
              tab={
                <>
                  {item?.tabName}
                  <CandidatesSpan>{listOfDrivesDetails?.count}</CandidatesSpan>
                </>
              }
              key={item?.key}
            >
              <DriveTable
                listOfDrivesDetails={listOfDrivesDetails}
                onPageChange={onPageChange}
                currentPage={currentPage}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                driveRoles={driveRoles}
                setDriveRoles={setDriveRoles}
                driveMode={driveMode}
                setDriveMode={setDriveMode}
                driveStatus={driveStatus}
                setDrivestatus={setDriveStatus}
                filteApplied={getDariveData}
                isLoading={isLoading}
                corporateStatus={corporateStatus}
                onChangeSort={onChangeSort}
                occurrence={occurrence}
              />
            </TabPane>
          )
        })}
      </StyledTab>
    </>
  )
}

export default DrivePage
